import React from "react";

const ShopIcon = ({ color = "#FFF", width = 24, height= 24, className = "", ...props }) => (
        <svg  width={width}
              height={height}
              viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              className={className}
              {...props}>
            <path
                d="M8.4375 7.63291V5.35941C8.4375 4.7316 8.96916 4.22266 9.625 4.22266H13.7812C14.4371 4.22266 14.9688 4.7316 14.9688 5.35941V7.63291M4.875 19.0004H19.125C20.4367 19.0004 21.5 17.9826 21.5 16.7269V9.90642C21.5 8.6508 20.4367 7.63291 19.125 7.63291H4.875C3.56332 7.63291 2.5 8.6508 2.5 9.90642V16.7269C2.5 17.9826 3.56332 19.0004 4.875 19.0004Z"
                stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    )
;

export default ShopIcon;